<template>
  <div class="text-center">
    Provide the zipcode for your service location.
    <form novalidate class="d-flex:t jc-center:t ai-center:t m-1" @submit.prevent="choose">
      <div class="d-flex p-y-1 flex-1-1:mo">
        <div class="input-container">
          <input
              v-vk-input
              v-vk-focus
              v-model="zipcode"
              type="text"
              class="input"
              selenium="zip-code-modal-input">
          <label class="input-label">Enter your zipcode</label>
        </div>
        <button class="btn m-l-1" selenium="zip-code-modal-button">OK</button>
      </div>
    </form>
  </div>
</template>

<script>
import { getCities } from '@homeservices/api-kit/search';

export default {
  name: 'choose-zipcode',
  data () {
    return {
      zipcode: '',
    };
  },
  methods: {
    choose () {
      getCities('US', this.zipcode)
        .then((response) => {
          if (response.data.results.length === 1) {
            const location = response.data.results[0];
            this.$emit('zipcode-chosen', {
              zipcode: location.zipcode,
              city: location.city,
              state: location.state,
            });
          } else if (response.data.results.length > 1) {
            const location = response.data.results[0];
            this.$emit('zipcode-chosen', { zipcode: location.zipcode });
          }
        })
        .catch(() => {
          // do nothing
        });
    },
  },
};
</script>
